import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { backgroundImage, respondTo } from '@vfuk/core-mixins'

import type { StyledFiftyFiftyBannerProps } from './FiftyFiftyBanner.style.types'

import localThemes from '../themes/FiftyFiftyBanner.theme'

type FiftyFiftyBannerProps = Pick<StyledFiftyFiftyBannerProps, 'theme' | 'bodyPosition' | 'appearance'>
export const FiftyFiftyBanner = styled.div((props: FiftyFiftyBannerProps): FlattenSimpleInterpolation => {
  const localTheme = localThemes(props.theme)
  return css`
    display: flex;
    flex-direction: column-reverse;
    background: ${localTheme.appearance[props.appearance!].backgroundColor};
    min-height: ${localTheme.height.sm}px;

    ${respondTo.md(css`
      min-height: ${localTheme.height.md}px;
    `)}

    ${respondTo.lg(css`
      flex-direction: row;

      ${props.bodyPosition === 'right' &&
      `
        flex-direction: row-reverse;
      `}
    `)}
  `
})

type BannerContentProps = Pick<StyledFiftyFiftyBannerProps, 'theme' | 'bodyPosition'>
export const BannerContent = styled.div(
  (props: BannerContentProps): FlattenSimpleInterpolation => css`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: ${props.theme.spacing.responsive[3].sm}px;

    ${respondTo.md(css`
      padding: ${props.theme.spacing.responsive[5].md}px;
    `)}

    ${respondTo.lg(css`
      padding: ${props.theme.spacing.responsive[10].lg}px;
      width: 50%;

      ${props.bodyPosition === 'left' &&
      css`
        padding-left: 0;
        justify-content: flex-end;
      `}

      ${props.bodyPosition === 'right' &&
      css`
        padding-right: 0;
        justify-content: flex-start;
      `}
    `)}
  `,
)

export const ContentWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    width: 100%;

    ${respondTo.lg(css`
      max-width: 440px;
    `)}
  `,
)

type BannerImageProps = Pick<StyledFiftyFiftyBannerProps, 'theme' | 'backgroundImage' | 'verticalAlign'>
export const BannerImage = styled.div((props: BannerImageProps): FlattenSimpleInterpolation => {
  const localTheme = localThemes(props.theme)
  return css`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${props.theme.spacing.responsive[3].sm}px;
    position: relative;
    min-height: 240px;

    ${props.verticalAlign &&
    css`
      ${props.verticalAlign === 'top' &&
      css`
        padding-top: 0;
        align-items: flex-start;
      `}

      ${props.verticalAlign === 'bottom' &&
      css`
        padding-bottom: 0;
        align-items: flex-end;
      `}
    `}

    ${respondTo.md(css`
      min-height: ${localTheme.height.md}px;
      padding: ${props.theme.spacing.responsive[6].md}px;

      ${props.verticalAlign &&
      css`
        ${props.verticalAlign === 'top' &&
        css`
          padding-top: 0;
        `}

        ${props.verticalAlign === 'bottom' &&
        css`
          padding-bottom: 0;
        `}
      `}
    `)}

    ${respondTo.lg(css`
      width: 50%;
    `)}

    ${props.backgroundImage &&
    css`
      ${backgroundImage(props.backgroundImage)}
    `}
  `
})

type SecondaryImageWrapperProps = Pick<StyledFiftyFiftyBannerProps, 'bodyPosition'>
export const SecondaryImageWrapper = styled.div(
  (props: SecondaryImageWrapperProps): FlattenSimpleInterpolation => css`
    position: absolute;
    bottom: 0;
    max-width: 200px;

    ${props.bodyPosition}: 0;
  `,
)
